import React from "react";
import { useState } from "react";
import "./Sidebar.css";

export default function Sidebar(props) {
  const { menu } = props;

  const [active, setActive] = useState(menu?.[0]);

  const handleClickSidebar = (item) => {
    const dom = document.getElementById(item.id);
    if (dom) {
      //   dom.scrollIntoView()
      window.scrollTo({
        top: dom.offsetTop - 110, // -110是为了让顶部留出距离，在页面存在顶部固定导航栏时可以使用
        left: 0,
        behavior: "smooth",
      });
      setActive(item);
    }
  };

  return (
    <div className="sidebar">
      <div className="sidebar-body">
        <ul>
          {menu.map((item) => (
            <li
              key={item.name}
              className={active.name === item.name ? "active" : ""}
              onClick={() => handleClickSidebar(item)}
            >
              <div
                className={
                  active.name === item.name ? "bullet current" : "bullet"
                }
                id=""
              ></div>
              <div
                className={
                  active.name === item.name ? "text currentText" : "text"
                }
                id=""
              >
                {item.name}
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
